import React, { useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Footer() {
  const [email, setEmail] = useState("");
  const [label, setLabel] = useState("Join");

  const submit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/newsletter`, { email });
      setLabel("Joined ✓");
      setEmail("");
      setTimeout(() => setLabel("Join"), 2400);
    } catch (e2) {
      setLabel("Try again");
      setTimeout(() => setLabel("Join"), 2400);
    }
  };

  return (
    <footer id="visit">
      <div className="wrap">
        <div className="visit-grid">
          <div className="visit-block">
            <h4>Find us</h4>
            <p className="big">Cloud9</p>
            <p>14 Kahve Lane</p>
            <p>Shoreditch, London E2 7JN</p>
            <p style={{ marginTop: 14 }}>+44 20 7946 0958</p>
            <p>hello@cloud9.co.uk</p>
          </div>
          <div className="visit-block">
            <h4>Hours</h4>
            <div className="hours-row"><span>Mon – Thu</span><span>08:00 – 22:00</span></div>
            <div className="hours-row"><span>Fri – Sat</span><span>08:00 – 23:00</span></div>
            <div className="hours-row"><span>Sunday</span><span>09:00 – 21:00</span></div>
          </div>
          <div className="visit-block">
            <h4>Stay in the loop</h4>
            <p>New menu specials, roast days, and the occasional table for last-minute Fridays.</p>
            <form className="newsletter" onSubmit={submit}>
              <input
                type="email"
                placeholder="you@example.com"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button type="submit">{label}</button>
            </form>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© 2026 Cloud9.co.uk — Turkish grill, Indian kitchen, coffee house.</span>
          <div className="socials">
            <a href="#top">Instagram</a>
            <a href="#top">Facebook</a>
            <a href="#top">X</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
